export const PRIVACY_CHECK_ITEMS = [
  {
    id: 'ownerContact',
    label: 'Your contact info',
    helper: 'Your name, phone number, email, or home/billing address.'
  },
  {
    id: 'clientAccount',
    label: 'Account or invoice numbers',
    helper: 'Customer IDs, invoice or account numbers, microchip numbers, or card/payment details.'
  },
  {
    id: 'petIdentifiers',
    label: 'Pet details',
    helper: 'Your pet’s name, breed, age, or medical record number.'
  },
  {
    id: 'sensitiveNotes',
    label: 'Private notes',
    helper: 'Medical comments, payment notes, signatures, or anything you’d rather keep private.'
  }
];

const SIGNAL_RULES = [
  {
    id: 'phone',
    label: 'Possible phone number',
    pattern: /(?:\+?1[-.\s]?)?\(?\d{3}\)?[-.\s]\d{3}[-.\s]\d{4}/i
  },
  {
    id: 'email',
    label: 'Possible email address',
    pattern: /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i
  },
  {
    id: 'address',
    label: 'Possible street address',
    pattern: /\b\d{2,6}\s+[A-Z0-9][A-Z0-9.\s]+(?:street|st\.?|road|rd\.?|avenue|ave\.?|drive|dr\.?|lane|ln\.?|court|ct\.?|boulevard|blvd\.?)\b/i
  },
  {
    id: 'account',
    label: 'Possible client or account number',
    pattern: /\b(?:account|acct|client|customer|invoice|estimate|patient|medical record|mrn|microchip)\s*(?:#|no\.?|number|id)?\s*[:-]?\s*[A-Z0-9-]{3,}\b/i
  },
  {
    id: 'payment',
    label: 'Possible payment detail',
    pattern: /\b(?:visa|mastercard|amex|discover|card|payment|balance|paid by|cashier)\b/i
  }
];

export const detectPrivacySignals = (ocrText = '') => {
  const text = String(ocrText || '');

  if (!text.trim()) {
    return [];
  }

  return SIGNAL_RULES
    .filter(rule => rule.pattern.test(text))
    .map(rule => ({ id: rule.id, label: rule.label }));
};

export const createPrivacyReview = ({ checkedItems, detectedSignals, userNotes = '', redactionApplied = false, redactionBoxCount = 0 }) => ({
  status: detectedSignals.length ? 'sensitive_info_possible' : 'reviewed',
  checkedItems,
  detectedSignals,
  redactionApplied,
  redactionBoxCount,
  userNotes: userNotes.trim(),
  reviewedAt: new Date().toISOString()
});
